export default __webpack_public_path__ + "static/media/46.76dc1df9.jpg";